import { Injectable, Inject, DOCUMENT } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { isRtlLang } from 'src/functions/rtl.function';
import { ThemeService } from '../theme/theme.service';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {
  private localeSubject = new BehaviorSubject<string>('en-US'); // Default locale
  locale$ = this.localeSubject.asObservable();

  constructor(
    private translate: TranslateService,
    private themeService: ThemeService,
    @Inject(DOCUMENT) private document: Document
  ) {
    translate.onLangChange.subscribe((event) => {
      this.localeSubject.next(event.lang);
      this.document.documentElement.dir = isRtlLang(event.lang) ? 'rtl' : 'ltr';
      this.document.documentElement.lang = event.lang;
      moment.locale(event.lang);
      this.document.title = this.translate.instant(this.themeService.getTheme().siteName);
    })
  }

  setLanguages(langs: string[]){
    if(langs.length > 0){
      this.translate.addLangs(langs);
    }
  }

  get locale() {
    return this.localeSubject.value;
  }

  setLocale(lang: string) {
    this.localeSubject.next(lang);
    this.translate.use(lang);
  }
}
